.topDiv {
  background-color: var(--color-blue-violet);
  width: 100%;
  padding: 2px;
}

.spacer {
  display: flex;
  justify-content: space-between;
}

.ou {
  display: flex;
  justify-content: center;
  text-decoration: underline;
}

.topMessage {
  font-size: 20px;
  font-weight: 400;
  color: white;
  padding-left: 4px;
}

.date {
  font-size: 20px;
  font-weight: 400;
  color: hsla(0, 0%, 100%, 0.7);
  padding-left: 4px;
  margin-bottom: 4px;
}

.circle {
  background-color: var(--color-gray-200);
  cursor: pointer;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  margin: 3px;
}

.button {
  border-width: 1px;
  border-radius: 4px;
  padding: 10px;
  cursor: pointer;
  background-color: darkblue;
  color: white;
}

.buttonSpacer {
  display: flex;
  justify-content: center;
  padding: 4px;
}
